import { GALLERY } from "../mock";
import { ArrowUpRight } from "lucide-react";

export default function Gallery() {
  return (
    <section
      id="gallery"
      className="relative py-28 md:py-36 bg-[#0c0119] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
             The Gallery
            </div>
            <h2 className="font-display text-5xl md:text-6xl leading-[0.95] max-w-2xl">
              Recent <span className="text-jester">obsessions.</span>
            </h2>
          </div>
          <a
            href="#contact"
            className="flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-acid hover:text-white font-label"
          >
            See full portfolio <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
          {GALLERY.map((src, i) => (
            <div
              key={i}
              className="relative overflow-hidden rounded-xl group hover-lift aspect-square border border-white/5 hover:border-jester transition-colors duration-500"
            >
              <img
                src={src}
                alt={`Ceramic coating project ${i + 1}. Jester Werks Mississauga`}
                loading="lazy"
                decoding="async"
                width="800"
                height="800"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#120127] via-transparent to-transparent opacity-60 group-hover:opacity-90 transition-opacity" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <span className="text-xs uppercase tracking-[0.2em] font-label">
                  Project 0{i + 1}
                </span>
                <ArrowUpRight className="w-5 h-5 text-acid" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
